export default __webpack_public_path__ + "static/media/linus-s.144a27f2.webp";